import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { TdDialogService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit, OnDestroy {
  /**
   * Subscriptions
   */
  private _subs: Set<Subscription> = new Set();

  /**
   * Error keyword/message map
   */
  static readonly errorMap: {
    [errorKey: string]: string;
  } = {};

  /**
   * Constructor
   *
   * @param _router
   * @param _activatedRoute
   * @param _httpClient
   * @param _viewContainerRef
   * @param _dialogService
   */
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _httpClient: HttpClient,
    private _viewContainerRef: ViewContainerRef,
    private _dialogService: TdDialogService
  ) {}

  /**
   * Init
   */
  ngOnInit() {
    this._subs.add(
      this._activatedRoute.params.subscribe((data) => {
        this._httpClient.post('/api/auth/verify', { data }).subscribe((res) => {
          if (res['errors']) {
            const errorKey = res['errors'][0].keyword.replace(
                /___ERROR_NOT_FOUND$/,
                ''
              ),
              errorMessage = VerifyComponent.errorMap[errorKey] || errorKey;
            this._openAlert(errorMessage);
          } else if (res['result'].data) {
            this._openAlert(
              'თქვენ წარმატებით დარეგისტრირდით. მადლობთ, რომ სარგებლობთ ჩვენი სისტემით'
            )
              .afterClosed()
              .subscribe(() => {
                const isAdmin = this._router.url.includes('admin');
                const urlEndPoint = isAdmin ? 'private' : 'public';

                document.location.href = `${this.ssoUrl}/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
                // this._router.navigate(['/auth']);
              });
          }
        });
      })
    );
  }

  /**
   * Destroy
   */
  ngOnDestroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Opens alert dialog
   *
   * @param message
   * @param title
   */
  private _openAlert(message: string, title: string = '') {
    return this._dialogService.openAlert({
      message: message,
      viewContainerRef: this._viewContainerRef, //OPTIONAL
      title: title, //OPTIONAL, hides if not provided
      closeButton: 'დახურვა', //OPTIONAL, defaults to 'CLOSE'
      width: '400px' //OPTIONAL, defaults to 400px
    });
  }
  get ssoUrl(): string {
    return environment.ssoUrl;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/auth/components/verify/verify.component.ts